interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (inputValue?: string) => void;   // now optionally returns input value
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'danger' | 'warning' | 'info';

  // NEW OPTIONAL FIELDS
  inputEnabled?: boolean;
  inputLabel?: string;
  inputPlaceholder?: string;
  inputRequired?: boolean;
}
import { useState } from "react";

export const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "danger",

  // new props
  inputEnabled = false,
  inputLabel = "Reason",
  inputPlaceholder = "Enter reason...",
  inputRequired = false,
}: ConfirmDialogProps) => {
  const [inputValue, setInputValue] = useState("");

  if (!isOpen) return null;

  const variantClasses = {
    danger: "bg-red-600 hover:bg-red-700",
    warning: "bg-yellow-600 hover:bg-yellow-700",
    info: "bg-blue-600 hover:bg-blue-700",
  };

  const handleConfirm = () => {
    if (inputEnabled && inputRequired && !inputValue.trim()) return;
    onConfirm(inputEnabled ? inputValue : undefined);
    setInputValue("");
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm" onClick={onClose} />
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative bg-background-soft rounded-lg shadow-xl w-full max-w-md p-6">
          <h3 className="text-lg text-primary font-semibold mb-2">{title}</h3>
          <p className="text-primary-800 mb-6 whitespace-pre-line">{message}</p>

          {/* NEW INPUT FIELD */}
          {inputEnabled && (
            <div className="mb-6">
              <label className="block text-sm font-medium mb-1">
                {inputLabel}
              </label>
              <input
                type="text"
                className="w-full px-3 py-2 border rounded-lg focus:ring-primary-500 focus:border-primary-500"
                placeholder={inputPlaceholder}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                required={inputRequired}
              />
            </div>
          )}

          <div className="flex gap-3 justify-end">
            <button onClick={onClose} className="btn-secondary bg-background-deep hover:bg-background">
              {cancelText}
            </button>
            <button
              onClick={handleConfirm}
              disabled={inputEnabled && inputRequired && !inputValue.trim()}
              className={`
                px-4 py-2 rounded-lg text-white transition-colors 
                ${variantClasses[variant]}
                disabled:opacity-60 disabled:cursor-not-allowed
              `}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
